import React from 'react';
export interface Testimonial {
  initials: string;
  quote: string;
  name: string;
}
interface TestimonialsProps {
  items: Testimonial[];
  title?: React.ReactNode;
  bgClass: string;
}
export function Testimonials({
  items,
  title,
  bgClass
}: TestimonialsProps) {
  return <section className={`py-[60px] px-5 ${bgClass}`} data-id="element-180">
      <div className="max-w-[760px] mx-auto" data-id="element-181">
        {title && <div className="mb-7" data-id="element-182">{title}</div>}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-5" data-id="element-183">
          {items.map((item, index) => <div key={index} className="bg-card border border-cardBorder border-l-4 border-l-gold rounded-xl p-5 hover:border-gold/50 transition-colors" data-id="element-184">
              <div className="w-10 h-10 rounded-full bg-gold-gradient text-base font-black text-[14px] flex items-center justify-center mb-3" data-id="element-185">
                {item.initials}
              </div>
              <p className="text-[14px] text-text-secondary leading-relaxed mb-2.5 italic" data-id="element-186">
                "{item.quote}"
              </p>
              <p className="text-xs text-gold font-bold" data-id="element-187">{item.name}</p>
            </div>)}
        </div>
      </div>
    </section>;
}